import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NotFoundComponent {
  private _text?: string;
  get text(): string { return this._text ?? this.translateService.instant('COMMON.no_data'); }
  @Input() set text(value: string) { this._text = value; }
  constructor(private translateService: TranslateService) { }
}
